import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <Services />
        <Gallery />
        <About />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
